import React, { Component } from "react";

import Home from "./components/Home";
class HomePage extends Component {
  render() {
    return (
        <Home history={this.props.history} match={this.props.match} />
    );
  }
}

export default HomePage;
